/**
 * Ported from `nivex-design/apps/nivex-web-v3/src/lib/wealthScore.ts`.
 * Same five-tier language used everywhere a Wealth Score is shown — a score is never just a bare number.
 */
export const WEALTH_SCORE_BANDS = [
  { min: 0, label: 'Needs attention', color: 'var(--financial-status-critical)' },
  { min: 20, label: 'Below average', color: 'var(--financial-status-poor)' },
  { min: 40, label: 'Fair', color: 'var(--financial-status-fair)' },
  { min: 60, label: 'Good', color: 'var(--financial-status-good)' },
  { min: 80, label: 'Excellent', color: 'var(--financial-status-excellent)' },
] as const

export function wealthScoreBand(score: number): { label: string; color: string } {
  let match: (typeof WEALTH_SCORE_BANDS)[number] = WEALTH_SCORE_BANDS[0]
  for (const band of WEALTH_SCORE_BANDS) {
    if (score >= band.min) match = band
  }
  return match
}

/**
 * The next tier up from `score`, or `null` if already in the top band — used to phrase
 * "N points from Excellent" instead of a bare forecast number.
 */
export function nextWealthScoreBand(score: number): { label: string; pointsAway: number } | null {
  const next = WEALTH_SCORE_BANDS.find((band) => band.min > score)
  if (!next) return null
  return { label: next.label, pointsAway: next.min - score }
}
